export default __webpack_public_path__ + "static/media/progress-circle-2-3.90c1cad7.svg";